<div class="p-2">
    <p-dropdown styleClass="custom-dropdown" placeholder="Select Credit Union" [options]="userService.cuAccessData"
        optionLabel="modifiedName" (onChange)="onChangeCU($event)" [filter]="true" filterBy="modifiedName"></p-dropdown>
    <div class="flex mt-8">
        <button
            class="w-full text-white enabled:bg-main font-medium rounded-lg text-base px-3 py-2 text-center enabled:hover:bg-green-600 disabled:bg-gray-300 disabled:cursor-not-allowed"
            (click)="saveNewCU()" [disabled]="!isCUDifferent">Apply</button>
    </div>
</div>